/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconOperations = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 26 26"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 26px;
      `}
      {...props}
    >
      <g
        fill={fill}
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M15.54 19.663c2.25.357 2.66-1.483 2.26-3.043l-.291-1.137a1.438 1.438 0 0 1 .761-1.648l1.21-.595-1.21-.595c-.612-.3-.93-.988-.761-1.647.092-.363.196-.767.292-1.138.4-1.56-.01-3.4-2.26-3.043M10.939 19.663c-2.25.357-2.66-1.483-2.26-3.043l.292-1.137a1.439 1.439 0 0 0-.76-1.648L7 13.24l1.21-.595c.612-.3.93-.988.76-1.647-.091-.363-.195-.767-.29-1.138-.4-1.56.01-3.4 2.259-3.043" />
        <path d="M22.84 24.76H3.64a1.92 1.92 0 0 1-1.92-1.92V3.64c0-1.06.86-1.92 1.92-1.92h19.2c1.06 0 1.92.86 1.92 1.92v19.2c0 1.06-.86 1.92-1.92 1.92z" />
      </g>
    </svg>
  ),
);
